
import { computed, defineComponent, PropType } from 'vue'

import OkAudioRecordMini from '@/modules/OktellModule/components/OkAudioRecordMini/index.vue'

type ChatMessageFile = {
    link: string
    name: string
    contentType: string
}

export default defineComponent({
    components: {
        OkAudioRecordMini,
    },
    props: {
        file: {
            type: Object as PropType<ChatMessageFile>,
            default: null,
        },
    },
    setup(props) {
        const isVoiceMessage = computed(() => {
            if (props.file) {
                if (props.file.contentType === 'audio/ogg; codecs=opus') {
                    return true
                }
            }

            return false
        })

        const isImg = computed(() => {
            if (props.file) {
                if (props.file.contentType.includes('image')) {
                    return true
                }
            }

            return false
        })

        return {
            isVoiceMessage,
            isImg,
        }
    },
})
